import {createFileRoute} from '@tanstack/react-router'
import LeagueOfLeaguesPage from '../../landing/LeagueOfLeaguesPage'

export const Route = createFileRoute('/leaderboards/leagues')({
    component: RouteComponent,
})

function RouteComponent() {
    return <LeagueOfLeaguesPage />
}
